export const AgreementStatus = {
  APPLICATION: 'APPLICATION',
  SIGNED: 'SIGNED',
  SIGNING_IN_PROGRESS: 'SIGNING_IN_PROGRESS',
  SIGNING_FAILED: 'SIGNING_FAILED',
  CREDIT_OFFER: 'CREDIT_OFFER',
  REJECTED: 'REJECTED',
  ELIGIBILITY_CHECKER_FAILED: 'ELIGIBILITY_CHECKER_FAILED',
  POST_EVALUATION_FAILED: 'POST_EVALUATION_FAILED',
  LEVLA_OFFER: 'LEVLA_OFFER',
  LEVLA_REJECTED: 'LEVLA_REJECTED',
  LEVLA_OFFER_SIGN_REQUEST: 'LEVLA_OFFER_SIGN_REQUEST',
  ACCEPT_LEVLA_FAILED: 'ACCEPT_LEVLA_FAILED',
  LEVLA_SIGNING_FAILED: 'LEVLA_SIGNING_FAILED',
  LOAN_OFFER: 'LOAN_OFFER',
  LOAN_ID_PROTECT_OFFER: 'LOAN_ID_PROTECT_OFFER',
  LOAN_PARTNER_OFFER: 'LOAN_PARTNER_OFFER',
  CREATED: 'CREATED',
  OPEN_BANKING_RECOVERY: 'OPEN_BANKING_RECOVERY',
  INCOME_VERIFICATION_RECOVERY: 'INCOME_VERIFICATION_RECOVERY',
  EXPIRED: 'EXPIRED',
  EVALUATION_IN_PROGRESS: 'EVALUATION_IN_PROGRESS',
  EVALUATION_FAILED: 'EVALUATION_FAILED',
  FAILED: 'FAILED',
  MANUAL_APPROVAL: 'MANUAL_APPROVAL',
} as const;

export type AgreementStatusValue = (typeof AgreementStatus)[keyof typeof AgreementStatus];
